(function () {
  'use strict';

  const drawer  = document.getElementById('ut-cart-drawer');
  const overlay = document.getElementById('ut-cart-overlay');
  const closeBtn = document.getElementById('ut-cart-close');
  const body    = document.getElementById('ut-cart-body');
  const footer  = document.getElementById('ut-cart-footer');

  if (!drawer) return;

  let isOpen    = false;
  let isBusy    = false; // prevents overlapping AJAX calls

  // ── GSAP initial state ────────────────────────────────────────────

  gsap.set(drawer,  { x: '100%' });
  gsap.set(overlay, { autoAlpha: 0 });

  // ── Open / Close ──────────────────────────────────────────────────

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    document.body.classList.add('ut-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');

    gsap.timeline()
      .to(overlay, { autoAlpha: 1, duration: 0.25, ease: 'none' })
      .to(drawer,  { x: 0, duration: 0.38, ease: 'power3.out' }, '<');
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;

    gsap.timeline({
      onComplete: function () {
        document.body.classList.remove('ut-drawer-open');
        drawer.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
      }
    })
      .to(drawer,  { x: '100%', duration: 0.32, ease: 'power3.in' })
      .to(overlay, { autoAlpha: 0, duration: 0.22, ease: 'none' }, '<0.08');
  }

  // ── Cart icon / link intercept ────────────────────────────────────
  // Prevent navigation to /cart for any in-page cart links; open drawer instead.

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // Match /cart but not /cart/add, /checkout, etc.
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    if (href === cartUrl || href === cartUrl + '/') {
      // Don't intercept the "continue shopping" link inside our own drawer footer
      if (link.classList.contains('ut-cart-continue') || link.classList.contains('ut-cart-empty__link')) return;
      e.preventDefault();
      openDrawer();
    }
  });

  // ── Overlay + close button ────────────────────────────────────────

  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  // ── Subscribe to cartUpdate (sticky ATC, product form, etc.) ─────

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    // Avoid reopening if the update originated inside our own drawer
    if (event && event.source === 'ut-cart-drawer') return;
    refreshCart().then(openDrawer);
  });

  // ── Section Rendering API refresh ────────────────────────────────

  function refreshCart() {
    if (isBusy) return Promise.resolve();
    isBusy = true;

    return fetch('/?sections=ut-cart-drawer')
      .then(function (r) {
        if (!r.ok) throw new Error('section_render_failed');
        return r.json();
      })
      .then(function (sections) {
        const doc = new DOMParser().parseFromString(sections['ut-cart-drawer'], 'text/html');

        // Swap body and footer inner content (elements themselves stay, preserving GSAP state on #ut-cart-drawer)
        const ids = ['ut-cart-body', 'ut-cart-footer'];
        ids.forEach(function (id) {
          const live = document.getElementById(id);
          const next = doc.getElementById(id);
          if (live && next) live.innerHTML = next.innerHTML;
        });

        // Update count badge in header
        const liveGroup = document.querySelector('.ut-cart-drawer__heading-group');
        const nextGroup = doc.querySelector('.ut-cart-drawer__heading-group');
        if (liveGroup && nextGroup) liveGroup.innerHTML = nextGroup.innerHTML;

        // Update cart count bubble(s) in the page header via cart.js
        updateCartBubble();
      })
      .catch(function (err) {
        console.error('[UT Cart] refresh failed:', err);
      })
      .finally(function () {
        isBusy = false;
      });
  }

  // ── Cart bubble count update ──────────────────────────────────────

  function updateCartBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
          const ariaHidden = bubble.querySelector('[aria-hidden="true"]');
          const visHidden  = bubble.querySelector('.visually-hidden');
          if (ariaHidden) ariaHidden.textContent = cart.item_count;
          if (visHidden)  visHidden.textContent  = cart.item_count;
          bubble.classList.toggle('hidden', cart.item_count === 0);
        });
      })
      .catch(function () {/* non-critical */});
  }

  // ── Quantity change + remove (delegated from #ut-cart-body) ──────

  body.addEventListener('click', function (e) {

    // ─ Minus button
    const minusBtn = e.target.closest('.ut-qty-minus');
    if (minusBtn) {
      const stepper = minusBtn.closest('.ut-qty-stepper');
      const key     = stepper.dataset.key;
      const input   = stepper.querySelector('.ut-qty-stepper__input');
      const current = parseInt(input.value, 10);
      const next    = Math.max(0, current - 1); // 0 = remove
      applyQtyChange(key, next, stepper);
      return;
    }

    // ─ Plus button
    const plusBtn = e.target.closest('.ut-qty-plus');
    if (plusBtn) {
      const stepper = plusBtn.closest('.ut-qty-stepper');
      const key     = stepper.dataset.key;
      const input   = stepper.querySelector('.ut-qty-stepper__input');
      const current = parseInt(input.value, 10);
      applyQtyChange(key, current + 1, stepper);
      return;
    }

    // ─ Remove button
    const removeBtn = e.target.closest('.ut-cart-item__remove');
    if (removeBtn) {
      const key  = removeBtn.dataset.key;
      const item = removeBtn.closest('.ut-cart-item');
      applyQtyChange(key, 0, item);
    }
  });

  function applyQtyChange(key, quantity, busyEl) {
    if (isBusy) return;

    // Optimistic loading state
    const item = busyEl.closest('.ut-cart-item') || busyEl;
    item.classList.add('is-loading');

    changeCartItem(key, quantity)
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        // Publish so other components (e.g. sticky ATC count, header) can react
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ut-cart-drawer' });
      })
      .catch(function (err) {
        item.classList.remove('is-loading');
        console.error('[UT Cart] qty change failed:', err);
      });
  }

  // ── AJAX helpers ──────────────────────────────────────────────────

  function changeCartItem(key, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_change_failed');
      return r.json();
    });
  }

})();
